export default "__VITE_ASSET__D$o2Jq2k__"